/* eslint-disable */
export default {
  noActiveCalls: 'Nessuna chiamata attiva',
  currentCall: 'Chiamata corrente',
  ringCall: 'Chiamata in arrivo',
  onHoldCall: 'Chiamata in attesa',
  otherDeviceCall: 'Chiamate in corso sugli altri dispositivi',
  confirmation: 'Conferma',
  confirmMergeToConference: 'Aggiungere alla conferenza telefonica?',
  mergeToConference: 'Unisci',
  conferenceCall: 'Conferenza telefonica',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
